// keep track of what path has been mounted, what is in redux, which saga has been started, etc

var cache = {};

export function getCache(path, variable) {
  var joinedPath = Array.isArray(path) ? path.join('.') : path;

  var cachePart = cache[joinedPath] || {};

  if (variable) {
    return cachePart[variable];
  } else {
    return cachePart;
  }
}

export function setCache(path, object) {
  var joinedPath = Array.isArray(path) ? path.join('.') : path;
  cache[joinedPath] = Object.assign(cache[joinedPath] || {}, object);

  return cache[joinedPath];
}

export function resetCache() {
  cache = {};
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/kea/es/kea/cache/index.js
// module id = 41
// module chunks = 0